/** Stub for embed bundle: @vue-util/forms (veevalidate) */
import { ref, computed } from 'vue';

function useField(name, rules, opts = {}) {
  const initial = opts.initialValue ?? (rules === undefined ? '' : null);
  const value = ref(initial);
  const errorMessage = computed(() => undefined);
  return { value, errorMessage };
}

export const veevalidate = { useField };
